import { useEffect, useState } from 'react';

import { CoreVideoService } from '../CoreVideoService';

export const useVideoElement = (): HTMLVideoElement | null => {
  const [videoElement, setVideoElement] = useState<HTMLVideoElement | null>(CoreVideoService.videoElement);

  useEffect(() => {
    return CoreVideoService.addEventListener('videoElement', (newVideoElement) => {
      setVideoElement(newVideoElement);
    });
  }, []);

  return videoElement;
};
